import { defineStoryFunnel } from "./_story-funnel-schema";
import { BOOST_STORY_EFFECTS, BOOST_STORY_OFFER_HREF, buildBoostStoryOffer } from "./boost-story-shared";

export const boostWeightStory = defineStoryFunnel({
  kind: "story-funnel",
  slug: "boost-weight-story",
  version: 2,
  effects: BOOST_STORY_EFFECTS,
  meta: { title: "Boost Weight Story" },
  offer: { href: BOOST_STORY_OFFER_HREF },
  screens: [
    {
      "id": "hook",
      "role": "story",
      "layout": "image-overlay",
      "heading": "WHY WON\u2019T THAT STUBBORN BELLY FAT GO AWAY?",
      "contentTop": 276,
      "headingAccent": [
        "STUBBORN BELLY FAT"
      ],
      "image": {
        "src": "/static/images/story-funnels/weight-hook.webp",
        "alt": "Man looking at his torso in a mirror",
        "geometry": {
          "x": -197,
          "y": -168,
          "width": 704,
          "height": 704
        },
        "fade": {
          "start": 172,
          "end": 533.606
        }
      },
      "blocks": [
        {
          "type": "paragraphs",
          "paragraphs": [
            "You used to eat what you wanted, and your jeans still fit.",
            "Now your waistline keeps growing, your jawline vanished, and that gut won't budge.",
            "But you\u2019re active. You eat right. You've even cut back on the beer\u2026",
            "So why does it feel harder than ever to drop a few pounds?"
          ],
          "emphasis": [
            "So why does it feel harder than ever to drop a few pounds?"
          ]
        },
        {
          "type": "rating",
          "stars": 5,
          "label": "4.8/5",
          "text": "5798 REVIEWS"
        }
      ],
      "cta": "WHY CAN\u2019T I LOSE THIS GUT? \u2192"
    },
    {
      "id": "problem",
      "role": "story",
      "layout": "image-overlay",
      "heading": "IT\u2019S LIKE PUTTING IN THE WORK STOPPED WORKING.",
      "contentTop": 312,
      "headingAccent": [
        "PUTTING IN THE WORK STOPPED WORKING"
      ],
      "image": {
        "src": "/static/images/story-funnels/weight-problem.webp",
        "alt": "Man resting on a gym bench",
        "geometry": {
          "x": -5,
          "y": 40,
          "width": 442,
          "height": 403
        },
        "fade": {
          "start": 209,
          "end": 497.393
        }
      },
      "blocks": [
        {
          "type": "paragraphs",
          "paragraphs": [
            "You used to eat what you wanted, and your jeans still fit.",
            "Now your waistline keeps growing, your jawline vanished, and that gut won't budge.",
            "But you\u2019re active. You eat right. You've even cut back on the beer\u2026",
            "So why does it feel harder than ever to drop a few pounds?"
          ],
          "emphasis": [
            "So why does it feel harder than ever to drop a few pounds?"
          ]
        }
      ],
      "cta": "FIND OUT WHAT\u2019S GOING ON \u2192"
    },
    {
      "id": "testosterone",
      "role": "story",
      "layout": "content-panel",
      "heading": "YOUR BELLY IS GROWING, BUT SOMETHING ELSE IS SHRINKING.",
      "contentTop": 168,
      "headingAccent": [
        "SHRINKING"
      ],
      "blocks": [
        {
          "type": "paragraphs",
          "paragraphs": [
            "When you're young, staying lean can feel effortless. But as you get older, your body starts changing. Around age 30, testosterone levels can decline by 1% per year.",
            "Testosterone is a main driver for:"
          ],
          "emphasis": [
            "Testosterone is a main driver for:"
          ]
        },
        {
          "type": "list",
          "items": [
            "\ud83d\udcaa Your body composition",
            "\ud83c\udfcb\ufe0f Your muscle maintenance",
            "\ud83e\udde0 Your energy and vitality",
            "\u26a1\ufe0f Your strength and recovery"
          ]
        },
        {
          "type": "paragraphs",
          "paragraphs": [
            "Year after year, that decline starts to add up."
          ]
        }
      ],
      "cta": "WHAT CAN I DO ABOUT IT? \u2192"
    },
    {
      "id": "boost-timeline",
      "role": "story",
      "layout": "image-overlay",
      "heading": "LOSE THE DAD BOD. KEEP YOUR EDGE.",
      "contentTop": 184,
      "headingAccent": [
        "KEEP YOUR EDGE"
      ],
      "image": {
        "src": "/static/images/story-funnels/weight-timeline.webp",
        "alt": "Man doing a dumbbell row in a gym",
        "geometry": {
          "x": -7,
          "y": 25,
          "width": 382,
          "height": 349
        },
        "fade": {
          "start": 68,
          "end": 293.367
        }
      },
      "blocks": [
        {
          "type": "paragraphs",
          "paragraphs": [
            "Mars Men Boost supports your testosterone in four ways: MAKE MORE T, FREE YOUR T, PROTECT YOUR T, + OPTIMIZE IT.",
            "What could your next 90 days look like?"
          ],
          "emphasis": [
            "Mars Men Boost",
            "What could your next 90 days look like?"
          ],
          "accent": [
            "Mars Men Boost"
          ]
        },
        {
          "type": "timeline",
          "items": [
            {
              "label": "\u26a1 DAY 7:",
              "title": "IGNITION",
              "paragraphs": [
                "You're finally getting some momentum."
              ]
            },
            {
              "label": "\ud83d\udd25 DAY 30:",
              "title": "SPARK",
              "paragraphs": [
                "Your workouts get stronger. Your effort shows up in the mirror."
              ]
            },
            {
              "label": "\ud83d\ude80 DAY 90:",
              "title": "LIFTOFF",
              "paragraphs": [
                "Your belly is shrinking. Your muscles are showing. You look leaner, stronger, more confident."
              ]
            }
          ]
        },
        {
          "type": "paragraphs",
          "paragraphs": [
            "You didn't work this hard to settle for a dad bod."
          ],
          "accent": [
            "You didn't work this hard to settle for a dad bod."
          ],
          "emphasis": [
            "You didn't work this hard to settle for a dad bod."
          ]
        }
      ],
      "cta": "LET\u2019S SEE THE PROOF \u2192"
    },
    {
      "id": "reviews",
      "role": "story",
      "layout": "image-overlay",
      "heading": "4.78 Stars.\n503,128+ MEN\nON MARS",
      "contentTop": 159,
      "headingAccent": [
        "4.78",
        "503,128+"
      ],
      "image": {
        "src": "/static/images/story-funnels/weight-reviews.webp",
        "alt": "Man checking his reflection in a locker room",
        "geometry": {
          "x": -6,
          "y": 27,
          "width": 381,
          "height": 348
        },
        "fade": {
          "start": 27,
          "end": 286.599
        }
      },
      "blocks": [
        {
          "type": "reviews",
          "items": [
            {
              "id": "michael-s",
              "rating": 5,
              "heading": "At 40, I Finally Lost My Stubborn Gut and Feel 25 Again",
              "paragraphs": [
                "\u201cWent from having a gut that seemed impossible to get rid of and zero energy even with caffeine to feeling upbeat, focused, and motivated to be physically active. I've been losing fat where I need to and gaining muscle everywhere else. At 40 most men are still where I was before I started Mars Men. I suggest it to all of my friends now.\u201d"
              ],
              "author": "Michael S.",
              "verified": true
            },
            {
              "id": "robert-w",
              "rating": 5,
              "heading": "Lightest I've Been Since High School",
              "paragraphs": [
                "\u201c3rd month in and I'm absolutely transforming. Lightest I've been since high school. More energy through the day. Blood work looking great. Just, overall, a new person and feeling great!"
              ],
              "author": "Robert W.",
              "verified": true
            },
            {
              "id": "thomas-e",
              "rating": 5,
              "heading": "Lost 100lbs and Got My Life Back at 51",
              "paragraphs": [
                "\u201cI've recently gotten my life back after many years of a stress filled journey. Mars men was a huge part of that journey. I've lost 100lbs regaining my manhood and feeling better than I have since my 30s, 51 now. More energy and more zest for life. I'm on my second 90 day supply and no plans on stopping anytime soon.\u201d"
              ],
              "author": "Thomas E.",
              "verified": true
            },
            {
              "id": "jeffery-g",
              "rating": 5,
              "heading": "Down 10 Pounds and Feeling 20 Years Younger",
              "paragraphs": [
                "\u201cAfter the first week, I noticed my stamina coming back. After the second week, I noticed I was under 250 lbs. for the first time in years. Week two also brought better nights' sleep and energy to do projects after work. It has me moving in the right direction, and I am looking forward to the Second month. Down 10lbs and feeling 20 years younger.\u201d"
              ],
              "author": "Jeffery G.",
              "verified": true
            }
          ]
        }
      ],
      "cta": "ALRIGHT, SHOW ME THE DEAL \u2192"
    },
    buildBoostStoryOffer(),
  ],
});
